<svg
  #rect
  width="65"
  height="12"
  viewBox="0 0 65 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    class="tl-element line"
    x="0"
    y="0"
    width="1"
    height="0"
    fill="#01b25d"
  />
  <rect x="0" y="0" width="65" height="20" fill="#01b25d" />
  <text
    x="3"
    y="14"
    width="60"
    height="20"
    fill="black"
    font-size="12"
    font-family="Arial"
  >
    {{ finalText }}
  </text>
</svg>
